import { cva } from 'class-variance-authority';
import type { Size } from '../types';

const sizeVariants = {
  large: 'text-size-headline-3xl ml-[0.7rem]',
  medium: 'text-size-headline-xl ml-[0.6rem]',
  small: 'text-size-headline-base ml-1',
  byBreakpoint: 'text-size-headline-xl ml-[0.6rem] lg:text-size-headline-3xl lg:ml-[0.7rem]',
} satisfies Record<Size, string>;

export const flag = cva('text-color-text-light absolute font-bold', {
  variants: {
    size: sizeVariants,
  },
  defaultVariants: { size: 'medium' },
});
